<script>
export default {
	props: {
		transparent: Boolean,
		dense: Boolean,
		hideIcon: Boolean,
		iconType: String,
		icon: String,
		iconHtml: String,
		iconImage: [Object, String],
		text: String,
		iconColor: String,
		lowercase: Boolean,
	},
}
</script>

<template>
	<v-btn
		:style="{
			background: transparent && 'transparent!important',
			padding: dense && '0 3px',
			'text-transform': lowercase && 'none',
		}"
		text
		class="h100"
		height="100%"
		depressed
		small
		v-on="$listeners"
		v-bind="$attrs"
	>
		<CustomIcon
			v-if="!hideIcon"
			:icon-type="iconType"
			:icon="icon"
			:icon-html="iconHtml"
			:icon-image="iconImage"
			:color="iconColor || $vars.primarytext"
			class="mr-2"
		/>
		<HtmlOrSlot :text="text" :class="{ 'text-transform-none': dense }">
			<span class="font-1 text-wrap-nowrap">
				{{ text }}
			</span>
		</HtmlOrSlot>
		<slot name="bottom"></slot>
	</v-btn>
</template>

